import type { Dispatch } from 'redux';
import { createActionFactory, Feature } from '../../../shared';

export const contactCleanupDialogDismissedAction = createActionFactory(
    'ContactCleanupDialogDismissed',
    Feature.ContactCleanup
);

export const contactCleanupDialogDismissed = (dispatch: Dispatch) => () =>
    dispatch(contactCleanupDialogDismissedAction());
export type { DataActionFactory } from '../../../shared';
export type { Action } from '../../../shared';
